import { PropsWithChildren } from "react";

import { AppShell, Box } from "@mantine/core";

import Header from "../Header";
import SideMenu from "../SideMenu";
import OnboardingModal from "modules/user/components/OnboardingModal";

import { useHelpCrunch } from "modules/core/hooks/useHelpCrunch";

const AppLayout = ({ children }: PropsWithChildren) => {
  useHelpCrunch();

  return (
    <>
      <AppShell
        layout="alt"
        zIndex={198}
        header={{ height: 60 }}
        navbar={{ breakpoint: "sm", width: 240 }}
      >
        <Header />

        <SideMenu />

        <AppShell.Main>
          <Box p="xs">{children}</Box>
        </AppShell.Main>
      </AppShell>

      <OnboardingModal />
    </>
  );
};

export default AppLayout;
